export {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
} from "#dialog";
export { Dialog, DialogClose, DialogPortal, DialogTrigger } from "#dialog-primitives";
